"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Location = _interopRequireDefault(require("../../geom/Location"));

var _EdgeEndBuilder = _interopRequireDefault(require("./EdgeEndBuilder"));

var _NodeMap = _interopRequireDefault(require("../../geomgraph/NodeMap"));

var _RelateNodeFactory = _interopRequireDefault(require("./RelateNodeFactory"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var RelateNodeGraph =
/*#__PURE__*/
function () {
  function RelateNodeGraph() {
    _classCallCheck(this, RelateNodeGraph);

    RelateNodeGraph.constructor_.apply(this, arguments);
  }

  _createClass(RelateNodeGraph, [{
    key: "insertEdgeEnds",
    value: function insertEdgeEnds(ee) {
      for (var i = ee.iterator(); i.hasNext();) {
        var e = i.next();

        this._nodes.add(e);
      }
    }
  }, {
    key: "getNodeIterator",
    value: function getNodeIterator() {
      return this._nodes.iterator();
    }
  }, {
    key: "copyNodesAndLabels",
    value: function copyNodesAndLabels(geomGraph, argIndex) {
      for (var nodeIt = geomGraph.getNodeIterator(); nodeIt.hasNext();) {
        var graphNode = nodeIt.next();

        var newNode = this._nodes.addNode(graphNode.getCoordinate());

        newNode.setLabel(argIndex, graphNode.getLabel().getLocation(argIndex));
      }
    }
  }, {
    key: "build",
    value: function build(geomGraph) {
      this.computeIntersectionNodes(geomGraph, 0);
      this.copyNodesAndLabels(geomGraph, 0);
      var eeBuilder = new _EdgeEndBuilder.default();
      var eeList = eeBuilder.computeEdgeEnds(geomGraph.getEdgeIterator());
      this.insertEdgeEnds(eeList);
    }
  }, {
    key: "computeIntersectionNodes",
    value: function computeIntersectionNodes(geomGraph, argIndex) {
      for (var edgeIt = geomGraph.getEdgeIterator(); edgeIt.hasNext();) {
        var e = edgeIt.next();
        var eLoc = e.getLabel().getLocation(argIndex);

        for (var eiIt = e.getEdgeIntersectionList().iterator(); eiIt.hasNext();) {
          var ei = eiIt.next();

          var n = this._nodes.addNode(ei.coord);

          if (eLoc === _Location.default.BOUNDARY) n.setLabelBoundary(argIndex);else {
            if (n.getLabel().isNull(argIndex)) n.setLabel(argIndex, _Location.default.INTERIOR);
          }
        }
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return RelateNodeGraph;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return RelateNodeGraph;
}();

exports.default = RelateNodeGraph;

RelateNodeGraph.constructor_ = function () {
  this._nodes = new _NodeMap.default(new _RelateNodeFactory.default());
};